import { SegmentedControl } from 'components/SegmentedControl/SegmentedControl'
import { observer } from 'mobx-react-lite'
import Styles from './CollabItemStageActions.module.scss'

import { CollabItemStageActionsProps } from './Types'
import { CloseIcon } from 'components/StageActions/CloseIcon'
import { CheckIcon } from 'components/StageActions/CheckIcon'

const CollabItemStageActions = observer(({ item, isStaged, onAccept, onReject }: CollabItemStageActionsProps) => {
  const setActiveItem = (name: string) => (name === 'exclude' ? onReject(item.uuid) : onAccept([item.uuid]))

  return (
    <SegmentedControl
      items={[
        {
          name: 'exclude',
          icon: CloseIcon,
          iconClassName: Styles.excludeIcon,
          text: 'Exclude',
          highlighterClassName: Styles.excludedHighlighter,
        },
        {
          name: 'merge',
          icon: CheckIcon,
          iconClassName: Styles.mergeIcon,
          text: 'Merge',
          highlighterClassName: Styles.mergeHighlighter,
        },
      ]}
      slimButtons={true}
      buttonClassName={Styles.button}
      highlighterClassName={Styles.highlighter}
      activeItem={isStaged ? 'merge' : 'exclude'}
      onItemClick={setActiveItem}
    />
  )
})

export { CollabItemStageActions }
